import React from "react"

const RandomQuote = () => {
  const quotes = [
    ["You Grinnin', you Winnin'!"],
    ["Grin ... just better money."],
    ["No Premine. No ICO. Fairly launched."],
    ["100% NFT-Free Zone"],
    ["Privacy from the ground up."],
    ["Cryptocurrency - 99.9% nonsense, 0.1% Grin"],
    ["Mimblewhatble?"],
  ]

  var index = Math.floor(Math.random() * quotes.length)

  return (
  <div className="content">{quotes[index][0]}</div>
  )
}

export default RandomQuote